import { ActivityType } from 'rt/Core/ActivityType';
import store from '@/store';
import { ListsType } from 'rt/Core/ListsType';

class ActivityTypeMapping {
  private iconMapping: {
    [key: number]: string;
  } = {
    [ActivityType.CaseSolution]: 'icon-question5',
    [ActivityType.PhoneCall]: 'icon-phone',
    [ActivityType.Email]: 'icon-paperplane',
    [ActivityType.Fax]: 'icon-shredder',
    [ActivityType.Sms]: 'icon-mobile',
    [ActivityType.Generic]: 'icon-lamp5',
    [ActivityType.Letter]: 'icon-typewriter',
    [ActivityType.Memo]: 'icon-quill2',
    [ActivityType.Visit]: 'icon-location4',
  };

  toIcon(subTypeId: number): string {
    const def = this.getActivityTypeDefinition(subTypeId);
    if (def && def.infoData) {
      if (def.infoData && def.infoData['Icon'] && def.infoData['Icon'].value) {
        return def.infoData['Icon'].value;
      }
      return this.iconMapping[def.infoData['Type'].value];
    }
    return this.iconMapping[ActivityType.Generic];
  }

  toDefaultIcon(value: ActivityType) {
    return this.iconMapping[value];
  }

  private colorMapping: {
    [key: number]: string;
  } = {
    [ActivityType.CaseSolution]: '#ff7f0e',
    [ActivityType.PhoneCall]: '#2ca02c',
    [ActivityType.Email]: '#1f77b4',
    [ActivityType.Fax]: '#7f7f7f',
    [ActivityType.Sms]: '#3366cc',
    [ActivityType.Generic]: '#bcbd22',
    [ActivityType.Letter]: '#17becf',
    [ActivityType.Memo]: '#9467bd',
    [ActivityType.Visit]: '#e377c2',
  };

  toColor(subTypeId: number): string {
    const def = this.getActivityTypeDefinition(subTypeId);
    if (def && def.infoData) {
      if (def.infoData && def.infoData['Color'] && def.infoData['Color'].value) {
        return def.infoData['Color'].value;
      }
      return this.colorMapping[def.infoData['Type'].value];
    }
    return this.colorMapping[ActivityType.Generic];
  }

  toDefaultColor(value: ActivityType) {
    return this.colorMapping[value];
  }

  private getActivityTypeDefinition(
    subTypeId: number,
  ): {
    value: number;
    infoData: {
      color: { Value: string };
      icon: { Value: string };
      type: { Value: string };
    };
  } {
    const getter = store.getters['lists/list'];
    if (getter) {
      return getter(ListsType.ListActivityType).find((x) => x.value === subTypeId);
    }
    return null;
  }
}

export default new ActivityTypeMapping();
